// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sched-card {
  display: flex;
  align-items: flex-start;
  gap: 13px;
  padding: 17px 18px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-left: 4px solid var(--brand);
  border-radius: var(--radius);
  box-shadow: var(--shadow-xs);
}

.sched-ok {
  border-left-color: #16a34a;
  background: #f0fdf9;
}

.sched-ico {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: var(--radius-sm);
  background: var(--brand-100);
  color: var(--brand);
}

.sched-ok .sched-ico {
  background: #d1fae5;
  color: #065f46;
}

.sched-body {
  min-width: 0;
}

.sched-when {
  font-family: var(--font-display);
  font-size: 1.06rem;
  font-weight: 700;
  color: var(--text);
}

.sched-status {
  margin-top: 3px;
  font-size: 0.86rem;
  line-height: 1.55;
  color: var(--muted);
}

.sched-flags {
  display: flex;
  gap: 8px;
  margin-top: 11px;
}

.sched-flags span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: var(--radius-pill);
  background: var(--bg);
  border: 1px solid var(--border);
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--muted);
}

.sched-flags .sched-flag-on {
  background: #d1fae5;
  border-color: #a7f3d0;
  color: #065f46;
}
`, "",{"version":3,"sources":["webpack://./src/app/order/SchedulePanel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,mCAAmC;EACnC,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;EACjC,qBAAqB;EACrB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB","sourcesContent":[".sched-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 13px;\n  padding: 17px 18px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-left: 4px solid var(--brand);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-xs);\n}\n\n.sched-ok {\n  border-left-color: #16a34a;\n  background: #f0fdf9;\n}\n\n.sched-ico {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border-radius: var(--radius-sm);\n  background: var(--brand-100);\n  color: var(--brand);\n}\n\n.sched-ok .sched-ico {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.sched-body {\n  min-width: 0;\n}\n\n.sched-when {\n  font-family: var(--font-display);\n  font-size: 1.06rem;\n  font-weight: 700;\n  color: var(--text);\n}\n\n.sched-status {\n  margin-top: 3px;\n  font-size: 0.86rem;\n  line-height: 1.55;\n  color: var(--muted);\n}\n\n.sched-flags {\n  display: flex;\n  gap: 8px;\n  margin-top: 11px;\n}\n\n.sched-flags span {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 10px;\n  border-radius: var(--radius-pill);\n  background: var(--bg);\n  border: 1px solid var(--border);\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--muted);\n}\n\n.sched-flags .sched-flag-on {\n  background: #d1fae5;\n  border-color: #a7f3d0;\n  color: #065f46;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
